import {takeEvery} from 'redux-saga/effects';
import * as Sentry from '@sentry/browser';
import {WS_DATA_ATTENDANCE_MINIMUMS} from '../constants/contact.constants';
import {normalizeAttendanceMinimums} from '../../utils/models/AttendanceMinimums';

// The reducer ignores a malformed payload and stays pure; it is reported here instead.
// Global (not page-level) because the websocket message can arrive before the page mounts.
// A plain function: takeEvery runs it like a saga. Only the fact is reported, never the payload contents.
export function reportMalformedAttendanceMinimumsSaga({data}) {
    if (!normalizeAttendanceMinimums(data)) {
        Sentry.captureMessage('Malformed attendanceMinimums payload');
    }
}

export const attendanceMinimumsSagas = [
    takeEvery(WS_DATA_ATTENDANCE_MINIMUMS, reportMalformedAttendanceMinimumsSaga),
];
